import React, {Component, Fragment} from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import {DashboardBox7} from '../components';

class Dashboard7 extends Component {
	render() {
		const {pageTitle} = this.props;

		return (
			<Fragment>
				<Helmet title={pageTitle}/>
				<DashboardBox7/>
			</Fragment>
		);
	}
}

Dashboard7.defaultProps = {
	pageTitle: 'Dashboard'
};

Dashboard7.propTypes = {
	pageTitle: PropTypes.string
};

export default Dashboard7;
